import styled from "styled-components";
export const StyledStartButton = styled.button`
  box-sizing: border-box;
  display: block;
  align-items: center;
  margin: auto;
  margin-bottom: 10px;
  padding: 20px;
  border: 4px solid #4d2d5f;
  min-height: 20px;
  width: 50%;
  border-radius: 20px;
  background: #a6497e;
  font-family: Pixel, Arial, Helvetica, sans-serif;
  font-size: 0.8rem;
  cursor: pointer;
  color: white;
  max-width: 100;

  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;

// box-sizing: border-box;
// margin: 0 0 20px 0;
// padding: 20px;
// min-height: 30px;
// width: 50%;
// border-radius: 20px;
// border: none;
// color: white;
// background: #ae4883;
// font-family: Pixel, Arieal, Helvetica, sans-serif;
// font-size: 1rem;
// outline: none;
// cursor: pointer;
